import {h, Fragment} from "preact"
import Product from './Product'

export default ({ products, sidebarActive }) => {

    return (
        <div 
            class={`grid laptop:grid-cols-4 laptop:gap-5 grid-cols-2 gap-2 ${sidebarActive ? 'grid-collapse' : ''}`}
        >
            {products.map((hit, index) => (
                <Product 
                    key={hit.productId || index} 
                    product={hit} 
                />
            ))}
        </div>
    )
}
